const Edit = ({
  width = '24',
  height = '24',
  className = '',
  title = '',
  stroke = '1.5',
  role = ''
}): React.ReactNode => {
  const hidden = title && title.length > 0 ? false : true;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      stroke="#000000"
      aria-hidden={`${hidden}`}
      role={role ? role : hidden ? 'graphics-document' : 'img'}
    >
      {!hidden && <title>{title}</title>}
      <path
        d="M20.4917 3.50831C20.2079 3.22568 19.8709 3.00208 19.5002 2.85044C19.1294 2.69879 18.7324 2.62211 18.3318 2.62483C17.9313 2.62754 17.5353 2.70959 17.1667 2.86624C16.798 3.02288 16.4641 3.25103 16.1842 3.53748L4.10083 15.6208L2.625 21.375L8.37917 19.8991L20.4625 7.81581C20.749 7.53587 20.9771 7.20193 21.1337 6.8333C21.2904 6.46468 21.3724 6.06866 21.3752 5.66814C21.3779 5.26762 21.3012 4.87053 21.1495 4.49982C20.9979 4.1291 20.7743 3.79211 20.4917 3.50831Z"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
      />
      <path
        d="M15.8383 3.8833L20.1167 8.16163"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
      />
      <path
        d="M14.0933 5.6283L18.3717 9.90663"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
      />
      <path
        d="M4.10083 15.6208L8.38333 19.895"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
      />
    </svg>
  );
};

export default Edit;
